import { Input, Component, HostBinding, Output, EventEmitter, OnInit } from '@angular/core';
import { IconType } from '../icon/icon-types';
import { trigger, style, state, transition, animate } from '@angular/animations';

@Component({
  selector: 'suka-banner',
  template: `
    <div
      [@fadeAnimation]="{
        value: animationState,
        params: {
          fadeIn: 200,
          fadeOut: 200
        }
      }"
      (@fadeAnimation.done)="onFadeFinished($event)"
      class="banner banner--{{status}}"
      [ngClass]="{
        'banner--hidden': hide
      }"
    >
      <button
        *ngIf="dismissable"
        sukaButton="plain"
        (click)="onClose($event)"
        class="banner__close-button"
      >
        <suka-icon icon="x"></suka-icon>
      </button>

      <div class="banner__status-icon" *ngIf="status !== 'default'">
        <div class="banner__status-icon__wrapper">
          <suka-icon [icon]="statusIcon"></suka-icon>
        </div>
      </div>

      <div class="banner__content">
        <h5>{{title}}</h5>
        <div class="banner__description">
          <ng-content></ng-content>
        </div>
        <button *ngIf="actionLabel" sukaButton outline="true" (click)="onAction()">{{actionLabel}}</button>
      </div>
    </div>
  `,
  animations: [
    trigger('fadeAnimation', [
      state('default', style({ opacity: 1, transform: '*' })),
      transition('void => *', [style({ opacity: 0, transform: 'scale(.9)' }), animate('150ms cubic-bezier(.17,.67,.78,1.21)')]),
      transition(
        'default => closing',
        animate('150ms', style({ opacity: 0, transform: 'scale(.9)' })),
      ),
    ]),
  ]
})
export class Banner implements OnInit {
  statusIcon: IconType;
  hide = false;

  public animationState: 'default' | 'closing' = 'default';

  @Input() title;
  @Input() status: 'default' | 'info' | 'success' | 'attention' | 'alert' = 'default';
  @Input() dismissable = true;
  @Input() actionLabel = '';

  @Output() action = new EventEmitter();
  @Output() dismiss = new EventEmitter();

  ngOnInit() {
    switch (this.status) {
      case 'info':
        this.statusIcon = 'info';
        break;
      case 'success':
        this.statusIcon = 'check';
        break;
      case 'attention':
        this.statusIcon = 'alert-triangle';
        break;
      case 'alert':
        this.statusIcon = 'alert-circle';
        break;
    }
  }

  onAction() {
    this.action.emit();
  }

  onClose(event?: any) {
    this.animationState = 'closing';
    this.dismiss.emit();
  }

  onFadeFinished(event: AnimationEvent) {
    const itFinished = this.animationState === 'closing';

    if (itFinished) {
      this.hide = true;
    }
  }
}
